import CssIcon from "./Assets/Images/CssIcon";
import HtmlIcon from "./Assets/Images/HtmlIcon";
import NodeIcon from "./Assets/Images/NodeIcon";
import ReactBootstrapIcon from "./Assets/Images/ReactBootstrapIcon";
import ReactJsIcon from "./Assets/Images/ReactJsIcon";
import RenderIcon from "./Assets/Images/RenderIcon";
import RTKIcon from "./Assets/Images/RTKIcon";
import ChartIcn from "./Assets/Images/Chart.js_logo.svg.png";
import SassIcn from "./Assets/Images/icons/sass.svg";
import GnewsIcn from "./Assets/Images/Gnews.jpg";
import VirtualAssistant from "./Assets/Images/va.png";
import IPAPIIcn from "./Assets/Images/ipapi.png";
import WetherIcn from "./Assets/Images/openweathermap.png";
import DummyIcn from "./Assets/Images/dummyjson.png";
import instachat from "./Assets/Images/instachat.png";
import EMSImg from "./Assets/ProjectImage/emsimg.png";
import CartImg from "./Assets/ProjectImage/lifestore.png";
import ETImg from "./Assets/ProjectImage/mt2.png";
import GmailImg from "./Assets/ProjectImage/gmail.png";
import MCImg from "./Assets/ProjectImage/mc.png";
import GSImg from "./Assets/ProjectImage/goose.png";
import Ga4Img from "./Assets/ProjectImage/ga4.png";
import TaskImg from "./Assets/ProjectImage/task.png";
import NewsImg from "./Assets/ProjectImage/news1.png";
import defaultProject from "./Assets/Images/banner.jpg";
// import defaultProject from "./Assets/ProjectImage/default-placeholder.jpg";
import StripeIcn from "./Assets/Images/stripe_logo_icon_167962.png";
import MongodbIcon from "./Assets/Images/MongodbIcon";

// simplified helpers with maps

const techMap = {
  react: <ReactJsIcon size="20" />,
  "React Bootstrap": <ReactBootstrapIcon size="20" />,
  css: <CssIcon size="20" />,
  html: <HtmlIcon size="20" />,
  RTK: <RTKIcon size="20" />,
  node: <NodeIcon size="20" />,
  "render server": <RenderIcon size="20" />,
  MongoDB: <MongodbIcon size="20" />,
};

const imgTechMap = {
  sass: SassIcn,
  "Chart.js": ChartIcn,
  "gnews.io": GnewsIcn,
  "ipapi.co": IPAPIIcn,
  openweathermap: WetherIcn,
  "dummyjson API": DummyIcn,
  stripe: StripeIcn,
};

export function TechIcon(icon) {
  if (!icon) return null;
  if (techMap[icon]) return techMap[icon];
  if (imgTechMap[icon]) {
    return (
      <img
        src={imgTechMap[icon]}
        style={{ height: "20px" }}
        loading="lazy"
        alt={`${icon} icon`}
      />
    );
  }
  return null;
}

const projectMap = {
  ems: EMSImg,
  cart: CartImg,
  et: ETImg,
  gc: GmailImg,
  mc: MCImg,
  gse: GSImg,
  "ga-4": Ga4Img,
  taskboard: TaskImg,
  news: NewsImg,
  instachat: instachat,
  va: VirtualAssistant,
};

export function ProjectImage(image) {
  return projectMap[image] || defaultProject;
}

export const CommonService = { TechIcon, ProjectImage };
